export const bufferMonths = 3;
export const aDayInMs = 1000 * 60 * 60 * 24;
export const minBoundaryHour = 6; // inclusive
export const maxBoundaryHour = 23; // inclusive

export const getTodayDate = () => ({
  date: new Date(),
  dateInMs: new Date().getTime(),
  hours: new Date().getHours()
});

export const getStartOfTheDayInMs = (date) =>
  new Date(date).setHours(0, 0, 0, 0);

export const getRemainingTimeToday = () => {
  const today = getTodayDate().date;
  const aSecInMs = 1000;
  const aMinInMs = aSecInMs * 60;
  const anHourInMs = aMinInMs * 60;
  const timeLapsedToday =
    today.getSeconds() * aSecInMs +
    aMinInMs * today.getMinutes() +
    today.getHours() * anHourInMs;
  return aDayInMs - timeLapsedToday + 10; // 10ms - buffer
};

export const getTotalDaysInAMonth = (monthIndex, year) =>
  new Date(year, monthIndex + 1, 0).getDate();

const getDaysCount = (months, year) =>
  months.reduce((count, month) => count + getTotalDaysInAMonth(month, year), 0);

export const getTimeBoundaries = () => {
  const today = getTodayDate().date;
  const todayInMs = getStartOfTheDayInMs(today);
  const currentMonthIndex = today.getMonth();
  const year = today.getFullYear();
  const bufferArray = Array.from({ length: bufferMonths });
  const pastDaysCount =
    today.getDate() -
    1 +
    getDaysCount(
      bufferArray.map((_, index) => currentMonthIndex - index - 1),
      year
    );
  const pastDays = aDayInMs * pastDaysCount;
  const futureDaysCount =
    getTotalDaysInAMonth(currentMonthIndex, year) -
    today.getDate() +
    getDaysCount(
      bufferArray.map((_, index) => currentMonthIndex + index + 1),
      year
    );
  const futureDays = aDayInMs * futureDaysCount;
  return {
    pastBoundaryDateInMs: todayInMs - pastDays, // inclusive
    futureBoundaryDateInMs: todayInMs + futureDays + aDayInMs // exclusive
  };
};

export const get12Hour = (hour) => hour % 12 || 12;

export const getMeridian = (hour) => (hour < 12 ? 'AM' : 'PM');

export const getNextDay = (date) => getStartOfTheDayInMs(date) + aDayInMs;

export const get2DigitDateOrMonth = (date, key) =>
  new Date(date).toLocaleString('default', { [key]: '2-digit' });

// yyyy-mm-dd
export const getDateKey = (date) => {
  const currentDate = new Date(date);
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, 0);
  const day = currentDate.getDate().toString().padStart(2, 0);
  return [year, month, day].join('-');
};

export const getDateFromKey = (dateKey) => {
  const [year, month, day] = dateKey.split('-');
  if (year && month && day) {
    return new Date(year, month, day);
  }
};

// whole hour - e.g 8 AM, 9 AM, not 9:21 PM
export const isTimeAWholeHour = (dateTime) => {
  const date = new Date(dateTime);
  return date.getMinutes() === 0; // date.getSeconds() === 0
};

export const generateDateKeysUntilBoundaries = (
  pastInclusiveBoundaryInMs,
  futureExclusiveBoundaryInMs
) => {
  let currentDateInMs = getStartOfTheDayInMs(pastInclusiveBoundaryInMs);
  const datesAndKeys = [];
  while (currentDateInMs < futureExclusiveBoundaryInMs) {
    datesAndKeys.push({
      key: getDateKey(currentDateInMs),
      date: currentDateInMs
    });
    currentDateInMs += aDayInMs;
  }
  return datesAndKeys;
};
